import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import { QA_NAME_CALENDAR_GRID_DAY_LOAD_CHIP } from './CalendarGridDayLoadChip.constants'

import * as styles from './CalendarGridDayLoadChip.module.css'

function CalendarGridDayLoadChip({ children, elementRef, ...restProps }) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [children],
    externalRef: elementRef,
  })

  return (
    <FloatingTooltip
      content={overflow ? children : null}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <Text
        {...restProps}
        className={styles.CalendarGridDayLoadChip}
        qaName={QA_NAME_CALENDAR_GRID_DAY_LOAD_CHIP}
        ref={setContentOverflowRef}
      >
        {children}
      </Text>
    </FloatingTooltip>
  )
}

export default CalendarGridDayLoadChip
